import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Success } from "../../components";
import { withNamespaces } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  root: {},
}));

const SuccessPage = (props) => {
  const { t=()=>false } = props
  const history = useHistory();
  const { state } = useLocation();
  const classes = useStyles();
  React.useEffect(() => {
    // if (state) {
    //   setTimeout(() => {
    //     if (state?.path) {
    //       if (state?.main) {
    //         history.push({
    //           pathname: state?.path,
    //           state: {
    //             propertyId: state?.main?.propertyId,
    //             tab: state?.main?.tab,
    //             agreementId: state?.main?.agreementId
    //           }
    //         })
    //       }
    //       else {
    //         history.push(state?.path);
    //       }
    //     } else {
    //       history.goBack();
    //     }
    //   }, 3000);
    // } else {
    //   history.push(Routes.dashboard);
    // }
    setTimeout(() => {
      history.goBack(-1)

    }, 4000);

    // eslint-disable-next-line
  }, [state]);

  return (
    <div className={classes.root}>
      <div className={classes.select}>
        <Success t={t} failure={props?.failure ?? false} customLabel={state?.customLabel} />
      </div>
    </div>
  );
};

export default withNamespaces("amenitiesBooking")(SuccessPage)
